<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="plm_hd">Contents</h1>
<div class="sgc-toc-level-1">
<a href="#/Text/DEUT_genpref">General preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DEUT_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DEUT_bibliog">Select bibliography</a>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_bibliog#sigil_toc_id_1">Commentaries</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_bibliog#sigil_toc_id_2">Other works</a>
</div>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DEUT_abbrev">Chief abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/DEUT_intro">Introduction</a>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_intro#sigil_toc_id_3">1. The importance of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_intro#sigil_toc_id_4">2. The context of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_intro#sigil_toc_id_5">3. The structure of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_intro#sigil_toc_id_6">4. The date of the book</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_intro#sigil_toc_id_7">5. The relevance of the book</a>
</div>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/DEUT_ch01"><span class="bold2">A. Introducing the covenant (1:1 – 4:43)</span></a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/DEUT_ch01#sigil_toc_id_9">1. The leader and his partners (1:1–18)</a>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_10">1. Submissive leadership</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_11">2. Realistic leadership</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_12">3. Confident leadership</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_13">4. Sacrificial leadership</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_14">5. Shared leadership</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/DEUT_ch01#sigil_toc_id_15">6. Vulnerable leadership</a>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch02#sigil_toc_id_16" title="Link target outside of Sample">2. Afraid of the future? (1:19–46)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch02#sigil_toc_id_17" title="Link target outside of Sample">1. A secure future (1:19–25)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch02#sigil_toc_id_18" title="Link target outside of Sample">2. A poor memory (1:26–33)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch02#sigil_toc_id_19" title="Link target outside of Sample">3. A lost opportunity (1:34–46)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch03#sigil_toc_id_20" title="Link target outside of Sample">3. Time to begin again (2:1 – 3:11)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch03#sigil_toc_id_21" title="Link target outside of Sample">1. God is merciful</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch03#sigil_toc_id_22" title="Link target outside of Sample">2. God is generous</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch03#sigil_toc_id_23" title="Link target outside of Sample">3. God is just</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch03#sigil_toc_id_24" title="Link target outside of Sample">4. God is strong</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch03#sigil_toc_id_25" title="Link target outside of Sample">5. God is sovereign</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch04#sigil_toc_id_26" title="Link target outside of Sample">4. Present blessings encourage future service (3:12–29)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch04#sigil_toc_id_27" title="Link target outside of Sample">1. Love the Lord’s people (3:12–22)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch04#sigil_toc_id_28" title="Link target outside of Sample">2. Exalt the Lord’s name (3:23–24)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch04#sigil_toc_id_29" title="Link target outside of Sample">3. Accept the Lord’s will (3:25–29)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch05#sigil_toc_id_30" title="Link target outside of Sample">5. Seeing him who is invisible (4:1–43)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch05#sigil_toc_id_31" title="Link target outside of Sample">1. The generous Giver (4:1–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch05#sigil_toc_id_32" title="Link target outside of Sample">2. The sovereign Lord (4:13–28)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch05#sigil_toc_id_33" title="Link target outside of Sample">3. The merciful Deliverer (4:29–34)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch05#sigil_toc_id_34" title="Link target outside of Sample">4. The incomparable Lover (4:35–49)</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DEUT_ch06" title="Link target outside of Sample"><span class="bold2">B. Expounding the covenant (4:44 – 11:32)</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch06#sigil_toc_id_36" title="Link target outside of Sample">6. Proclaimed in a loud voice (4:44 – 5:22)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_37" title="Link target outside of Sample">1. Their historical context</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_38" title="Link target outside of Sample">2. Their authoritative source</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_39" title="Link target outside of Sample">3. Their inclusive appeal</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_40" title="Link target outside of Sample">4. Their didactic style</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_41" title="Link target outside of Sample">5. Their obligatory nature</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_42" title="Link target outside of Sample">6. Their theological basis</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch06#sigil_toc_id_43" title="Link target outside of Sample">7. Their contemporary relevance</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch07#sigil_toc_id_44" title="Link target outside of Sample">7. Truth to tell (5:23 – 6:25)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch07#sigil_toc_id_45" title="Link target outside of Sample">1. Honour the Lord (5:23 – 6:3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch07#sigil_toc_id_46" title="Link target outside of Sample">2. Love the Lord (6:4–5)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch07#sigil_toc_id_47" title="Link target outside of Sample">3. Confess the Lord (6:6–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch07#sigil_toc_id_48" title="Link target outside of Sample">4. Remember the Lord (6:10–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch07#sigil_toc_id_49" title="Link target outside of Sample">5. Serve the Lord (6:13–25)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch08#sigil_toc_id_50" title="Link target outside of Sample">8. God’s people in a new land (7:1–26)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch08#sigil_toc_id_51" title="Link target outside of Sample">1. A holy people (7:1–6a)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch08#sigil_toc_id_52" title="Link target outside of Sample">2. A chosen people (7:6b–16)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch08#sigil_toc_id_53" title="Link target outside of Sample">3. A secure people (7:17–26)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch09#sigil_toc_id_54" title="Link target outside of Sample">9. God’s word for a time of change (8:1–20)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch09#sigil_toc_id_55" title="Link target outside of Sample">1. God’s fatherly training (8:1–6)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch09#sigil_toc_id_56" title="Link target outside of Sample">2. God’s undeserved generosity (8:7–16)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch09#sigil_toc_id_57" title="Link target outside of Sample">3. God’s sovereign demands (8:17–20)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch10#sigil_toc_id_58" title="Link target outside of Sample">10. When rebels are forgiven (9:1–29)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch10#sigil_toc_id_59" title="Link target outside of Sample">1. The invincible God (9:1–5)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch10#sigil_toc_id_60" title="Link target outside of Sample">2. The rebellious pilgrims (9:6–24)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch10#sigil_toc_id_61" title="Link target outside of Sample">3. The dependent intercessor (9:25–29)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch11#sigil_toc_id_62" title="Link target outside of Sample">11. Love matters most (10:1 – 11:32)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch11#sigil_toc_id_63" title="Link target outside of Sample">1. Love’s generosity (10:1–11)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch11#sigil_toc_id_64" title="Link target outside of Sample">2. Love’s initiative</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch11#sigil_toc_id_65" title="Link target outside of Sample">3. Love’s priority</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch11#sigil_toc_id_66" title="Link target outside of Sample">4. Love’s obligation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch11#sigil_toc_id_67" title="Link target outside of Sample">5. Love’s pledge</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DEUT_ch12" title="Link target outside of Sample"><span class="bold2">C. Applying the covenant (12:1 – 26:19)</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch12#sigil_toc_id_69" title="Link target outside of Sample">12. Honouring God (12:1 – 14:29)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch12#sigil_toc_id_70" title="Link target outside of Sample">1. Honouring God by our worship (12:1 – 13:18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch12#sigil_toc_id_71" title="Link target outside of Sample">2. Honouring God in our conduct (14:1–21)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch12#sigil_toc_id_72" title="Link target outside of Sample">3. Honouring God through our giving (14:22–29)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch13#sigil_toc_id_73" title="Link target outside of Sample">13. Festivals of praise (15:1 – 16:17)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch13#sigil_toc_id_74" title="Link target outside of Sample">1. Every seven years (15:1–18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch13#sigil_toc_id_75" title="Link target outside of Sample">2. Year by year (15:19–23)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch13#sigil_toc_id_76" title="Link target outside of Sample">3. Three times a year (16:1–17)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch14#sigil_toc_id_77" title="Link target outside of Sample">14. Responsible leadership (16:18 – 18:22)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch14#sigil_toc_id_78" title="Link target outside of Sample">1. Judges (16:18 – 17:3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch14#sigil_toc_id_79" title="Link target outside of Sample">2. Kings (17:14–20)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch14#sigil_toc_id_80" title="Link target outside of Sample">3. Priests (18:1–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch14#sigil_toc_id_81" title="Link target outside of Sample">4. Prophets (18:15–22)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch15#sigil_toc_id_82" title="Link target outside of Sample">15. When things go wrong (19:1–21)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch15#sigil_toc_id_83" title="Link target outside of Sample">1. The killer (19:1–13)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch15#sigil_toc_id_84" title="Link target outside of Sample">2. The thief (19:14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch15#sigil_toc_id_85" title="Link target outside of Sample">3. The false witness (19:15–21)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch16#sigil_toc_id_86" title="Link target outside of Sample">16. Soldiers with a difference (20:1–20)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch16#sigil_toc_id_87" title="Link target outside of Sample">1. A confident minority (20:1–4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch16#sigil_toc_id_88" title="Link target outside of Sample">2. A dedicated minority (20:5–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch16#sigil_toc_id_89" title="Link target outside of Sample">3. A compassionate minority</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch17#sigil_toc_id_90" title="Link target outside of Sample">17. Families in need (21:1–23)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch17#sigil_toc_id_91" title="Link target outside of Sample">1. A murdered man or woman (21:1–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch17#sigil_toc_id_92" title="Link target outside of Sample">2. A captured woman (21:10–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch17#sigil_toc_id_93" title="Link target outside of Sample">3. A deprived son (21:15–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch17#sigil_toc_id_94" title="Link target outside of Sample">4. A depraved son (21:18–22)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch17#sigil_toc_id_95" title="Link target outside of Sample">5. An executed criminal (21:22–23)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch18#sigil_toc_id_96" title="Link target outside of Sample">18. Loving the neighbours (22:1 – 23:16)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_97" title="Link target outside of Sample">1. Lost property (22:1–4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_98" title="Link target outside of Sample">2. Improper clothing (22:5)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_99" title="Link target outside of Sample">3. Protecting birds (22:6)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_100" title="Link target outside of Sample">4. Protecting others (22:8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_101" title="Link target outside of Sample">5. Mixing the wrong things together (22:9–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_102" title="Link target outside of Sample">6. The sanctity of sex (22:13–30)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_103" title="Link target outside of Sample">7. Clean worshippers (23:1–8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_104" title="Link target outside of Sample">8. Personal hygiene (23:9–11)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_105" title="Link target outside of Sample">9. Public health (23:12–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch18#sigil_toc_id_106" title="Link target outside of Sample">10. Helping the helpless (23:15–16)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch19#sigil_toc_id_107" title="Link target outside of Sample">19. More about the neighbours (23:17–25)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch19#sigil_toc_id_108" title="Link target outside of Sample">1. Pure worship (23:17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch19#sigil_toc_id_109" title="Link target outside of Sample">2. Clean money (23:18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch19#sigil_toc_id_110" title="Link target outside of Sample">3. Generous help (23:19–20)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch19#sigil_toc_id_111" title="Link target outside of Sample">4. Dependable words (23:21–23)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch19#sigil_toc_id_112" title="Link target outside of Sample">5. Grateful sharing (23:24–25)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch20#sigil_toc_id_113" title="Link target outside of Sample">20. Basic rights (24:1 – 25:4)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_114" title="Link target outside of Sample">1. Protecting women (24:1–4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_115" title="Link target outside of Sample">2. Protecting newly married couples (24:5)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_116" title="Link target outside of Sample">3. Protecting debtors (24:6, 10–13, 17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_117" title="Link target outside of Sample">4. Protecting vulnerable people (24:7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_118" title="Link target outside of Sample">5. Protecting the community (24:8–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_119" title="Link target outside of Sample">6. Protecting the employee (24:14–15)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_120" title="Link target outside of Sample">7. Protecting the innocent (24:16)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_121" title="Link target outside of Sample">8. Protecting the weak (24:17–22)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_122" title="Link target outside of Sample">9. Protecting the offender (25:1–3)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch20#sigil_toc_id_123" title="Link target outside of Sample">10. Protecting animals (25:4)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch21#sigil_toc_id_124" title="Link target outside of Sample">21. Community care (25:5–19)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch21#sigil_toc_id_125" title="Link target outside of Sample">1. A bereaved wife (25:5–10)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch21#sigil_toc_id_126" title="Link target outside of Sample">2. A violent brawler (25:11–12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch21#sigil_toc_id_127" title="Link target outside of Sample">3. A dishonest tradesman (25:13–16)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch21#sigil_toc_id_128" title="Link target outside of Sample">4. A cruel opponent (25:17–19)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch22#sigil_toc_id_129" title="Link target outside of Sample">22. What happens when we worship (26:1–19)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch22#sigil_toc_id_130" title="Link target outside of Sample">1. Acknowledge his generosity (26:1–4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch22#sigil_toc_id_131" title="Link target outside of Sample">2. Recall his faithfulness (26:5–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch22#sigil_toc_id_132" title="Link target outside of Sample">3. Honour his uniqueness (26:10)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch22#sigil_toc_id_133" title="Link target outside of Sample">4. Obey his commands (26:11–19)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch22#sigil_toc_id_134" title="Link target outside of Sample">5. Affirm his truth (26:16–19)</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DEUT_ch23" title="Link target outside of Sample"><span class="bold2">D. Confirming the covenant (27:1 – 30:20)</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch23#sigil_toc_id_136" title="Link target outside of Sample">23. Carefully follow all his commands (27:1 – 29:1)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch23#sigil_toc_id_137" title="Link target outside of Sample">1. Displaying the law (27:1–4, 8)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch23#sigil_toc_id_138" title="Link target outside of Sample">2. Building an altar (27:5–7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch23#sigil_toc_id_139" title="Link target outside of Sample">3. Making a response (27:9–26)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch23#sigil_toc_id_140" title="Link target outside of Sample">4. Facing the alternatives (28:1 – 29:1)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch24#sigil_toc_id_141" title="Link target outside of Sample">24. Choose life (29:2 – 30:20)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch24#sigil_toc_id_142" title="Link target outside of Sample">1. Past blessings (29:2–9)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch24#sigil_toc_id_143" title="Link target outside of Sample">2. Present resources (29:10–15)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch24#sigil_toc_id_144" title="Link target outside of Sample">3. Future perils (29:16–28)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch24#sigil_toc_id_145" title="Link target outside of Sample">4. Timeless facts (29:29 – 30:20)</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DEUT_ch25" title="Link target outside of Sample"><span class="bold2">E. Sharing the covenant (31:1 – 34:12)</span></span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch25#sigil_toc_id_147" title="Link target outside of Sample">25. Israel’s leaders and their message (31:1–29)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch25#sigil_toc_id_148" title="Link target outside of Sample">1. Israel’s leaders</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch25#sigil_toc_id_149" title="Link target outside of Sample">2. Israel’s message</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch26#sigil_toc_id_150" title="Link target outside of Sample">26. Learning by singing (32:1–47)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch26#sigil_toc_id_151" title="Link target outside of Sample">1. God’s nature described (32:1–14)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch26#sigil_toc_id_152" title="Link target outside of Sample">2. God’s rivals condemned (32:15–18)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch26#sigil_toc_id_153" title="Link target outside of Sample">3. God’s grief expressed (32:19–33)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch26#sigil_toc_id_154" title="Link target outside of Sample">4. God’s mercy promised (32:34–43)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch27#sigil_toc_id_155" title="Link target outside of Sample">27. Parting words (33:1–29)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_156" title="Link target outside of Sample">1. The fact of love (33:2–5)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_157" title="Link target outside of Sample">2. The inevitability of conflict (33:6–7, 11, 20, 22)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_158" title="Link target outside of Sample">3. The priority of service (33:8–10)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_159" title="Link target outside of Sample">4. The assurance of support (33:12)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_160" title="Link target outside of Sample">5. The joy of fruitfulness (33:13–17)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_161" title="Link target outside of Sample">6. The promise of security (33:18–19)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_162" title="Link target outside of Sample">7. The necessity of obedience (33:20–21)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch27#sigil_toc_id_163" title="Link target outside of Sample">8. The guarantee of help (33:22–29)</span>
</div>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_ch28#sigil_toc_id_164" title="Link target outside of Sample">28. None like him (32:48–52; 34:1–12)</span>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch28#sigil_toc_id_165" title="Link target outside of Sample">1. God encouraged Moses</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch28#sigil_toc_id_166" title="Link target outside of Sample">2. God equipped Moses</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch28#sigil_toc_id_167" title="Link target outside of Sample">3. God disciplined Moses</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/DEUT_ch28#sigil_toc_id_168" title="Link target outside of Sample">4. God replaced Moses</span>
</div>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/DEUT_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_OT" title="Link target outside of Sample">The Bible Speaks Today: Old Testament series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_NT" title="Link target outside of Sample">The Bible Speaks Today: New Testament series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/DEUT_themes" title="Link target outside of Sample">The Bible Speaks Today: Bible Themes series</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/appen9" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DEUT_contents.vue?dc48713e